"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _CompanyConfig = require("../../constants/CompanyConfig");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsFooter = () => {
  const company = (0, _CompanyConfig.getCompanyConfig)();
  return /*#__PURE__*/_react.default.createElement(_material.AppBar, {
    position: "static",
    color: "primary",
    sx: {
      top: "auto",
      bottom: 0,
      bgcolor: "#3c8dbc"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Toolbar, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      flexGrow: 1
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2",
    color: "inherit"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Copyright "), " \xA9 ", company.copyrightYear, ".", " ", /*#__PURE__*/_react.default.createElement("a", {
    href: company.url,
    style: {
      color: "inherit",
      textDecoration: "none"
    }
  }, company.name))));
};
exports.DmsFooter = DmsFooter;